import { MiniLoader } from "components/loader.component";
import React, { useContext, useState } from "react";
import styled from "styled-components";
import deleteBin from "assets/svg/delete-bin.svg";
import { AppContext } from "context/app.provider";
import { getToken } from "utils/firebase";
import { axiosInstance } from "utils/api";

const Container = styled.div`
  width: 80%;
  max-width: 440px;
  background-color: #fff;
  border-radius: 20px;
  padding: 5rem;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  div.confirmationText {
    font-size: 1.8rem;
    color: #1c344f;
    font-weight: 500;
    margin-bottom: 3rem;
  }

  div.removed {
    font-size: 2.4rem;
    color: #1c344f;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  div.message {
    color: #b3b7c6;
    font-weight: 400;
    font-size: 1.4rem;
    text-align: center;
    margin-bottom: 2rem;
  }

  div.actions {
    button {
      outline: none;
      border: none;
      border-radius: 3px;
      font-weight: 500;
      font-size: 15px;
      min-width: 104px;
      height: 36px;
    }

    button.positive {
      margin-right: 1.2rem;
      color: #748595;
      background: none;
    }

    button.negative {
      background: #fef4e6;
      border: 1px solid #fbb051;
      box-shadow: 0px 4px 14px rgba(255, 123, 1, 0.1);
      color: #fbb051;
    }
  }
`;

function ProductDeleteConfirmation({ closeOverlay, productId, setError }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const { setProducts } = useContext(AppContext);

  const removeProdcut = (id) => {
    setProducts((prev) => prev.filter((item) => item.id !== id));
  };

  const onDelete = async () => {
    if (!productId) return;

    setError("");
    setLoading(true);

    try {
      let accessToken = await getToken();
      if (!accessToken) return;

      let response = await axiosInstance.delete(
        `/admin/product?product_id=${productId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setLoading(false);

      if (response.status === 200) {
        removeProdcut(productId);
        setSuccess(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
      setError(e.response?.data?.message);
      setTimeout(() => {
        setError("");
      }, 4000);
    }
  };

  return (
    <Container>
      {!success ? (
        <>
          <div className="confirmationText">
            Are you sure you want to remove this product?
          </div>

          <div className="actions">
            <button className="positive" onClick={onDelete}>
              {loading ? (
                <MiniLoader width="20px" color={"#748595"} />
              ) : (
                "Yes, delete"
              )}
            </button>

            <button className="negative" onClick={closeOverlay}>
              Don't delete
            </button>
          </div>
        </>
      ) : (
        <>
          <img src={deleteBin} alt="" />

          <div className="removed">Removed</div>

          <div className="message">
            You have succesfully removed product from list
          </div>

          <div className="actions">
            <button className="negative" onClick={closeOverlay}>
              Close
            </button>
          </div>
        </>
      )}
    </Container>
  );
}

export default ProductDeleteConfirmation;
